var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',[_vm._v(" world:"+_vm._s(_vm.selectProduct(_vm.region,_vm.worldName)))]),_c(_vm.formTemplate,{tag:"FormTemplates",attrs:{"world":_vm.worldName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }